import { IdoRecord } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

const normalizeNextContactTimeFixedFieldName = (idoRecord: IdoRecord): IdoRecord => {
	const jsonModel = idoRecord.jsonModel as NonNullable<IdoRecord['jsonModel']>;

	const fixedFieldName = 'NETZkultur_IdoModel_FieldTypes_NextContactTime_is_fixed';

	jsonModel.model.leftColumn = jsonModel.model.leftColumn.map((field) => {
		if (field.name.startsWith(fixedFieldName)) {
			field.name = fixedFieldName;
		}
		return field;
	});

	jsonModel.model.rightColumn = jsonModel.model.rightColumn.map((field) => {
		if (field.name.startsWith(fixedFieldName)) {
			field.name = fixedFieldName;
		}
		return field;
	});

	idoRecord.jsonModel = jsonModel;

	return idoRecord;
};

export class GetTheIdoJSONModelForAnIdoAndInstanceQueryCallback extends Callback<IdoRecord[]> {
	public constructor(
		private readonly setIdoRecord: (payload: IdoRecord | null) => void,
		private readonly setUnavailableIdoRecord: () => void = () => undefined
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: IdoRecord[]): void => {
		const model = successResponse[0];

		if (model === undefined) {
			return;
		}

		if (model.jsonModel) {
			this.setIdoRecord(normalizeNextContactTimeFixedFieldName(model));
			return;
		}

		this.setUnavailableIdoRecord();
	};
}
